import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import * as DOMPurify from 'dompurify';

import {
  getWidthBySideWidth,
  getHeightBySideWidth
} from '../../../../utils/hexagon';

import styles from './index.module.css';
import addIcon from '../../../../assets/Icons/add.svg';
import deleteIcon from '../../../../assets/Icons/delete-black.svg';
import { onKeyDown } from '../../../../utils/onKeyDown';

export const ORIGIN_HEX_SIZE_HEIGHT = 160;
export const ORIGIN_HEX_SIZE_WIDTH = 138.56406460551017;
export const COM_ITEM_GAP = 8;

const sanitizer = DOMPurify.sanitize;

const smallerSize = {
  transform: 'scale(0.8)',
  transformOrigin: '50% top'
};

export default function SkillHexagon(props) {
  const {
    sideWidth,
    name,
    nameFilter = '',
    onSelect,
    selected,
    showInPDF
  } = props;

  const width = sideWidth
    ? getWidthBySideWidth(sideWidth)
    : ORIGIN_HEX_SIZE_WIDTH;
  const height = sideWidth
    ? getHeightBySideWidth(sideWidth)
    : ORIGIN_HEX_SIZE_HEIGHT;

  const selectClick = () => {
    onSelect(selected);
  };

  return (
    <div
      role="button"
      data-cy="hexagon"
      onClick={selectClick}
      onKeyDown={e => onKeyDown(e, selectClick)}
      tabIndex={showInPDF ? -1 : 0}
      className="hexagonWrapper"
    >
      <div
        tabIndex={-1}
        className={clsx(
          styles.skill,
          selected ? styles.borderSelected : styles.borderUnselected,
          showInPDF && styles.noScale
        )}
        style={{
          width: width,
          height: height,
          marginRight: COM_ITEM_GAP
        }}
      >
        <div
          style={{
            width: width - 4,
            height: height - 4
          }}
          className={clsx(styles.skillAfter)}
        />
        <div
          style={{
            width: `${width - 4}px`,
            height: `${height - 4}px`
          }}
          className={clsx(styles.skillAfter, {
            [styles.selected]: selected === true
          })}
        />
        <div
          className={styles.skillContent}
          style={width < ORIGIN_HEX_SIZE_WIDTH ? { ...smallerSize } : {}}
        >
          <div className={styles.noIcon} />
          <div className={styles.nameOuter} tabIndex={showInPDF ? -1 : 0}>
            <div
              className={clsx(
                styles.name,
                showInPDF ? styles.noUnderline : '',
                {
                  [styles.skillContentSelected]: selected
                }
              )}
              tabIndex={-1}
              dangerouslySetInnerHTML={{
                __html: sanitizer(nameFilter || name)
              }}
            />
          </div>
          {!selected ? (
            <div
              className={styles.skillAddIconWrapper}
              tabIndex="0"
              role="button"
            >
              <img
                className={styles.addIcon}
                src={addIcon}
                alt="select skill"
              />
            </div>
          ) : (
            <div
              className={styles.skillDeleteIconWrapper}
              tabIndex="0"
              role="button"
            >
              <img src={deleteIcon} alt="delete skill" />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

SkillHexagon.propTypes = {
  sideWidth: PropTypes.number,
  name: PropTypes.string,
  nameFilter: PropTypes.string,
  onSelect: PropTypes.func,
  selected: PropTypes.bool,
  skillId: PropTypes.string,
  showInPDF: PropTypes.bool
};
